"use client";

import { useClickOutside } from "@repo/lib/hooks/common";
import { IconSortByMobile } from "@repo/assets/images";
import { CategorySortOptions } from "@repo/components";
import { useSortBy } from "@repo/lib/hooks/catalog";
import { BottomSheet } from "@repo/ui";
import cx from "classnames";
import { useTranslations } from "next-intl";
import { useRef } from "react";
const CategorySort = props => {
  const t = useTranslations("Common");
  const {
    sortOptions,
    selectedSort
  } = props;
  const {
    value,
    name
  } = selectedSort || {};
  const dropdownRef = useRef();
  const {
    handleSortBy,
    isBottomSheetOpen,
    handleToggleBottomSheet,
    handleToggleDropdown,
    isDropdownOpen
  } = useSortBy();
  useClickOutside(dropdownRef, () => {
    if (isDropdownOpen) handleToggleDropdown();
  });
  return <>
      <div className="bg-toolbar-sort-buttonBg border-toolbar-border text-toolbar-text flex h-[36px] w-full max-w-fit items-center border text-base sm:h-[44px]">
        <div className="hidden h-[36px] sm:h-[44px] md:relative md:flex">
          <button onClick={handleToggleDropdown} className="flex w-[235px] items-center px-3 text-start text-sm font-medium rtl:w-auto">
            <span className="text-toolbar-text me-1 whitespace-nowrap">
              {t("Sort_By")}:
            </span>
            <span className="text-toolbar-sort-active whitespace-nowrap">
              {name}
            </span>
            <IconSortByMobile className={cx("text-toolbar-activeIcon ms-auto transform transition-transform duration-300", {
            "rotate-180": !isDropdownOpen
          })} data-sentry-element="IconSortByMobile" data-sentry-source-file="CategorySort.jsx" />
          </button>
          {isDropdownOpen && <div className="border-toolbar-sort-sortBorder bg-toolbar-bg absolute end-0 top-[48px] z-[45] w-[250px] border shadow-lg" ref={dropdownRef}>
              <CategorySortOptions sortOptions={sortOptions} handleSortBy={handleSortBy} handleToggle={handleToggleDropdown} isDropdown={true} selectedValue={value} />
            </div>}
        </div>
        <button onClick={handleToggleBottomSheet} className="flex items-center space-x-2 px-3 md:hidden rtl:space-x-reverse">
          <span className="text-toolbar-sort-active font-medium">{name}</span>
          <IconSortByMobile className={cx("text-toolbar-activeIcon transform transition-transform duration-300", {
          "rotate-180": !isBottomSheetOpen
        })} data-sentry-element="IconSortByMobile" data-sentry-source-file="CategorySort.jsx" />
        </button>
        <BottomSheet isOpen={isBottomSheetOpen} onClose={handleToggleBottomSheet} title={t("Sort_By")} variant="auto" data-sentry-element="BottomSheet" data-sentry-source-file="CategorySort.jsx">
          <CategorySortOptions sortOptions={sortOptions} handleSortBy={handleSortBy} handleToggle={handleToggleBottomSheet} isDropdown={false} selectedValue={value} data-sentry-element="CategorySortOptions" data-sentry-source-file="CategorySort.jsx" />
        </BottomSheet>
      </div>
    </>;
};
export default CategorySort;